module.exports = __webpack_public_path__ + "assets/img/media_14.e0da0db6.png";